import { render, staticRenderFns } from "./BuyerDataComponent.vue?vue&type=template&id=7d7482f4&scoped=true&"
import script from "./BuyerDataComponent.vue?vue&type=script&lang=js&"
export * from "./BuyerDataComponent.vue?vue&type=script&lang=js&"
import style0 from "./BuyerDataComponent.vue?vue&type=style&index=0&id=7d7482f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7482f4",
  null
  
)

export default component.exports